import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-top-notch',
  templateUrl: './modal-top-notch.component.html',
  styleUrls: ['./modal-top-notch.component.scss']
})
export class ModalTopNotchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    console.log('top notch init')
  }

}
